import type { GeoPointInput } from 'types/graphql-base'
import {
  GEO_POINT_PRECISION,
  MAX_LATITUDE,
  MAX_LONGITUDE,
  MIN_LATITUDE,
  MIN_LONGITUDE,
} from 'shared/constants/geoPoint'

export const formatCoordinate = (value: number) =>
  value.toFixed(GEO_POINT_PRECISION)

export const formatGeoPoint = ({ latitude, longitude }: GeoPointInput) =>
  `${formatCoordinate(latitude)}, ${formatCoordinate(longitude)}`

const isInRange = (value: number, min: number, max: number) =>
  Number.isFinite(value) && value >= min && value <= max

export const parseGeoPoint = (
  latitude: string,
  longitude: string
): GeoPointInput | null => {
  if (!latitude || !longitude) return null

  const point = { latitude: Number(latitude), longitude: Number(longitude) }

  return isInRange(point.latitude, MIN_LATITUDE, MAX_LATITUDE) &&
    isInRange(point.longitude, MIN_LONGITUDE, MAX_LONGITUDE)
    ? point
    : null
}
